import { render, staticRenderFns } from "./TPrimary.vue?vue&type=template&id=dbb4b1a6&scoped=true&"
import script from "./TPrimary.vue?vue&type=script&lang=js&"
export * from "./TPrimary.vue?vue&type=script&lang=js&"
import style0 from "./TPrimary.vue?vue&type=style&index=0&id=dbb4b1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb4b1a6",
  null
  
)

export default component.exports